export const isValidValue = value =>
  value !== null && value !== undefined && value !== '' && !Number.isNaN(value);

// 보여줄 때 사용
export const formatValue = (value, placeholder = '-', options = {}) => {
  if (!isValidValue(value)) return placeholder;

  if (options.isNumber) {
    const number = Number(value);
    if (Number.isNaN(number)) return placeholder;

    return number.toLocaleString(undefined, {
      minimumFractionDigits: options.decimals || 0,
      maximumFractionDigits: options.decimals || 0,
    });
  }

  return value;
};

// formData API 요청 시 처리
export const parseFormValue = (value, type = 'string') => {
  if (!isValidValue(value)) return undefined;

  if (type === 'number') {
    const num = Number(value);
    return Number.isNaN(num) ? undefined : num;
  }

  if (type === 'boolean') {
    return value === 'true';
  }

  return value;
};

export const formatStatus = status => {
  if (!status) return '-';

  return status.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
};

export const formatInventoryHistoryMethod = method => {
  if (!method) return '-';

  const specialCaseMap = {
    increase: 'Add',
    force_update: 'Replace',
    decrease: 'Remove',
  };

  if (method in specialCaseMap) {
    return specialCaseMap[method];
  }

  return method.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
};
